import { clamp } from '../core/math';
import type { Vessel } from './vessel';

// How far one ship's lookouts can make out another. Shared by the AI
// captains and the player's own lookouts so both see by the same rules.

export interface SightConditions {
  /** Meteorological visibility, m. */
  visibility: number;
  /** 0 night .. 1 day. */
  daylight: number;
  /** Significant wave height, m. */
  seaState: number;
}

/**
 * Range at which `observer` can see `target`: a ship shows her canvas far
 * beyond where her hull is visible, a man at the masthead sees further,
 * swell hides small hulls, darkness closes in, and lights give her away.
 */
export function sightRange(observer: Vessel, target: Vessel, c: SightConditions): number {
  const lookout = observer.crew.lookout ? 1.15 : 0.8;
  const night = 1 - c.daylight;
  const size = Math.sqrt(target.ship.sx * target.ship.sy);
  let range = c.visibility * (0.75 + 0.25 * size) * lookout * (1 - clamp(c.seaState / 20, 0, 0.3));
  range *= 1 - night * 0.82;
  if (night > 0.5 && target.lights) range = Math.max(range, Math.min(c.visibility, 3200));
  return range;
}

/** How fast awareness of a ship at distance `d` builds (per second) when inside `range`. */
export function awarenessRate(d: number, range: number, skill: number): number {
  return (1.6 * (1 - d / range) + 0.15) * (0.6 + 0.4 * skill);
}
